
import extend from '@/utils/vuex-extend';
import { table } from '@/vuex-extend';
import { fetchList, createRole, updateRole, updateStatus, deleteRole } from '@/api/role';
import { Message } from 'element-ui';

export default extend(table, {
    namespaced: true,
    state: {
        searchForm: {}
    },
    actions: {
        async getList({ state, dispatch }, payload) {
            const { searchForm } = state;
            await dispatch('getData', {
                caller: fetchList,
                options: {
                    ...searchForm,
                    ...payload
                }
            });
        },
        async updateStatus({ dispatch }, payload) {
            await updateStatus(payload.id, { status: payload.status == 1 ? 0 : 1 });
            Message({
				type: "success",
				message: "修改成功!"
            });
            dispatch('getList');
        },
        async deleteRole({ dispatch }, payload) {
            let params = new URLSearchParams();
			params.append("ids", payload);
            await deleteRole(params);
            Message({
				type: "success",
				message: "删除成功!"
            });
            dispatch('getList');
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/modules/ums/role/list.js